export const HubertQualifiedSelectList = [
  {
    label: 'Qualified',
    value: 'qualified',
  },
  {
    label: 'Not qualified',
    value: 'not_qualified',
  },
];

export enum EInterviewQualified {
  Qualified = 'qualified',
  NotQualified = 'not_qualified',
}
